import React, { FC, useCallback, useMemo, useState } from 'react';
import { getEntityById } from '../../utils/DataAccessUtils';
import { approveAllAudits, approveAllAuditsByMatchStatus } from '../../thunks/cycle_runs_thunks';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Button, Dropdown, Menu, message, Spin } from 'antd';
import { DownOutlined, LoadingOutlined } from '@ant-design/icons';
import { ACC_AUDIT_MATCH_STATUSES } from '../../utils/AssetCycleUtils';

const MATCH_BY_STATUS_MENU_ITEMS = [
	{
		key: ACC_AUDIT_MATCH_STATUSES.MATCHED,
		label: 'matched',
	},
	{
		key: ACC_AUDIT_MATCH_STATUSES.MatchedWithVariance,
		label: 'matched with variance',
	},
	{
		key: ACC_AUDIT_MATCH_STATUSES.MatchedWithVariance,
		label: 'matched but needs verification',
	},
	{
		key: ACC_AUDIT_MATCH_STATUSES.NewAsset,
		label: 'new assets',
	},
];

const ACCAuditApproveAllAction: FC<any> = ({
	cycleRun,
	approveAllByMatchStatus,
	approveAll,
	onSuccess,
}): React.ReactElement => {
	const [updating, setUpdating] = useState(false);

	const onApproveAll = useCallback(() => {
		setUpdating(true);
		approveAll(cycleRun)
			.then(() => onSuccess && onSuccess())
			.catch(message.error)
			.finally(() => setUpdating(false));
	}, [approveAll, cycleRun, onSuccess]);

	const onApproveByMatchStatus = useCallback(
		(matchStatus) => () => {
			setUpdating(true);
			approveAllByMatchStatus(cycleRun, matchStatus)
				.then(() => onSuccess && onSuccess())
				.catch(message.error)
				.finally(() => setUpdating(false));
		},
		[approveAllByMatchStatus, cycleRun, onSuccess]
	);

	const approveAllMenu = useMemo(
		() => (
			<Menu>
				<Menu.Item key={1} onClick={onApproveAll}>
					Approve all
				</Menu.Item>
				{MATCH_BY_STATUS_MENU_ITEMS.map((menu) => (
					<Menu.Item key={menu.key} onClick={onApproveByMatchStatus(menu.key)}>
						{`Approve all '${menu.label}'`}
					</Menu.Item>
				))}
			</Menu>
		),
		[onApproveAll, onApproveByMatchStatus]
	);

	return (
		<Dropdown overlay={approveAllMenu}>
			<div className="flex flex-row items-center gap-2">
				<Button type="primary">
					<div className="flex flex-row items-center gap-2">
						<span>Approve All</span>
						<div>
							<DownOutlined />
						</div>
						{updating ? (
							<div className="ml-2">
								<Spin
									indicator={<LoadingOutlined style={{ fontSize: 16, color: '#FFF' }} spin />}
								/>
							</div>
						) : null}
					</div>
				</Button>
			</div>
		</Dropdown>
	);
};

const mapStateToProps = (state, ownProps) => ({
	cycleRun: getEntityById(ownProps.match.params.id, state.cycle_runs),
});

const mapDispatchToProps = (dispatch) => ({
	approveAll: (entity) => dispatch(approveAllAudits(ROLE_TYPES.BUYER)(entity)),
	approveAllByMatchStatus: (entity, matchStatus) =>
		dispatch(approveAllAuditsByMatchStatus(ROLE_TYPES.BUYER)(entity, matchStatus)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(ACCAuditApproveAllAction as any)
);
